import Vue from 'vue';
import store from '@/store';
import Router from 'vue-router';
import Landing from './views/Landing/index.vue';
import Numbers from './views/Onboarding/Numbers/index.vue';
import SearchNumber from './views/Onboarding/SearchNumber/index.vue';
import SelectNumber from './views/Onboarding/SelectNumber/index.vue';
import NumberPorting from './views/Onboarding/NumberPorting/index.vue';
import Checkout from './views/Onboarding/Checkout/index.vue';
import InviteTeam from './views/Onboarding/InviteTeam/index.vue';
import CreateGroups from './views/Onboarding/CreateGroups/index.vue';
import CallMenu from './views/Onboarding/CallFlow/CallMenu/index.vue';
import TextMenu from './views/Onboarding/TextFlow/index.vue';
import TextRoutePerson from './views/Onboarding/TextFlow/TextRoutePerson/index.vue';
import OnboardingMobile from './views/Onboarding/OnboardingMobile/index.vue';
import TextRouteGroup from './views/Onboarding/TextFlow/TextRouteGroup/index.vue';
import Redirect from './views/Auth/Redirect/index.vue';
import Transition from './views/Onboarding/Transition/index.vue';
import { isMobile } from '@/utils';

// Legal
import PrivacyPolicy from '@/views/Legal/PrivacyPolicy.vue';

Vue.use(Router);

// DO NOT CHANGE ROUTES ORDER, Back Button Logic!!!
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Landing',
      meta: { title: 'Voyyp: Unlimited Virtual Phone System' },
      component: Landing
    },
    {
      path: '/numbers',
      name: 'Numbers',
      meta: { title: 'Sign Up for Voyyp' },
      component: Numbers
    },
    {
      path: '/numbers/search',
      name: 'SearchNumber',
      meta: { title: 'Sign Up for Voyyp' },
      component: SearchNumber
    },
    {
      path: '/numbers/select',
      name: 'SelectNumber',
      meta: { title: 'Sign Up for Voyyp' },
      component: SelectNumber
    },
    {
      path: '/numbers/porting',
      name: 'Number Porting',
      meta: { title: 'Sign Up for Voyyp' },
      component: NumberPorting
    },
    {
      path: '/checkout',
      name: 'Checkout',
      meta: { title: 'Sign Up for Voyyp' },
      component: Checkout
    },
    {
      path: '/invite-team',
      name: 'InviteTeam',
      meta: { title: 'Invite Your Team', requiresAuth: true, step: 1 },
      component: InviteTeam
    },
    {
      path: '/create-groups',
      name: 'CreateGroups',
      meta: { title: 'Create Groups', requiresAuth: true, step: 2 },
      component: CreateGroups
    },
    {
      path: '/call-flow',
      name: 'CallMenu',
      meta: { title: 'Call Routing', requiresAuth: true, step: 3 },
      component: CallMenu
    },
    {
      path: '/text-flow/menu',
      name: 'TextMenu',
      meta: { title: 'Text Routing', requiresAuth: true, step: 4 },
      component: TextMenu
    },
    {
      path: '/text-flow/person',
      name: 'TextRoutePerson',
      meta: { title: 'Text Routing', requiresAuth: true, step: 4 },
      component: TextRoutePerson
    },
    {
      path: '/text-flow/group',
      name: 'TextRouteGroup',
      meta: { title: 'Text Routing', requiresAuth: true, step: 4 },
      component: TextRouteGroup
    },
    {
      path: '/onboarding-mobile',
      name: 'OnboardingMobile',
      meta: { title: 'Download Voyyp for Mobile', requiresAuth: true, step: 5 },
      component: OnboardingMobile
    },
    {
      path: '/redirect',
      meta: { title: 'Voyyp' },
      component: Redirect
    },
    {
      path: '/transition',
      meta: { title: 'Voyyp' },
      component: Transition
    },
    {
      path: '/legal/privacy-policy',
      name: 'PrivacyPolicy',
      meta: { title: 'Privacy Policy' },
      component: PrivacyPolicy
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title ? to.meta.title : 'Voyyp';
  const { auth, onboarding } = store.state;                                     

  if (to.meta.requiresAuth && !auth.authenticated) {
    next({ name: 'Landing' });
    return;
  }

  if (isMobile() && to.meta.step > 0) {
    next('/transition');
    return;
  }

  if (to.meta.requiresAuth && to.meta.step > onboarding.onboardingStep) {
    const step = onboarding.onboardingStep;
    
    if (step === 1) {
      next('/invite-team');
    } else if (step === 2) {
      next('/create-groups');
    } else if (step === 3) {
      next('/call-flow');
    } else {
      const baseRoute = '/text-flow/';
      const type = onboarding.phoneNumber.textFlow.type;            
      next(baseRoute + type);
    }
  }

  next();
});

export default router;
